import { ICreateRoleResponse } from '../models/role.model'
import { useCreateRoleUseCase } from '../useCases/useCreateRole.usecase'

export const useCreateRoleContainer = (): ICreateRoleResponse => {
  const { roleCreateForm, onSubmit, isLoading } = useCreateRoleUseCase()

  return { roleCreateForm, onSubmit, isLoading }
}
